import { render } from "./ResearcherInnovationDetail.vue?vue&type=template&id=04d7a7c4"
import script from "./ResearcherInnovationDetail.vue?vue&type=script&lang=js"
export * from "./ResearcherInnovationDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__